export enum IconCase {
  LE4_STEP = 'assets/tc-icons/step.png',
  JPEG = 'assets/tc-icons/jpg.png',
  MSWordX = 'assets/tc-icons/word.png',
  PDF = 'assets/tc-icons/pdf.gif',
  STL = 'assets/tc-icons/stl.png',
  UGMASTER = 'assets/tc-icons/nx.png',
  UGPART = 'assets/tc-icons/nx-drawing.png',
  DirectModel = 'assets/tc-icons/directmodel.png',
}

export class ItemRevisionDataset {
  public constructor(
    public name: string,
    public relation: string,
    public type: IconCase,
    public link?: string,
    public original_file_name?: string
  ) {}
}
